// extracted by mini-css-extract-plugin
export default {"BaseCell":"row-dragger-module__BaseCell--Kcb25","Box":"row-dragger-module__Box--GApk6","IconButton":"row-dragger-module__IconButton--PgvTL"};